import type { PlatformTypeName } from "@multi-chat/shared";

/** Operator-facing channel labels (presentation only; API values stay domain names). */
export type ChannelPresentationLabel = "WhatsApp" | "Messenger" | "Instagram";

export function channelPresentationLabel(
  platformType: PlatformTypeName,
): ChannelPresentationLabel {
  switch (platformType) {
    case "WHATSAPP":
      return "WhatsApp";
    case "FACEBOOK":
      return "Messenger";
    case "INSTAGRAM":
      return "Instagram";
    default: {
      const _exhaustive: never = platformType;
      return _exhaustive;
    }
  }
}

/** i18n key under `channel.*` for the operator-facing label. */
export function channelLabelI18nKey(
  platformType: PlatformTypeName,
): "whatsapp" | "messenger" | "instagram" {
  switch (platformType) {
    case "WHATSAPP":
      return "whatsapp";
    case "FACEBOOK":
      return "messenger";
    case "INSTAGRAM":
      return "instagram";
    default: {
      const _exhaustive: never = platformType;
      return _exhaustive;
    }
  }
}

/** Localized badge fill — provider color stays on the badge only. */
export function channelBadgeClassName(
  platformType: PlatformTypeName,
): string {
  switch (platformType) {
    case "WHATSAPP":
      return "bg-[#25D366] text-white";

    case "FACEBOOK":
      return "bg-[linear-gradient(to_top_right,#00B2FF_0%,#6C4CFF_48%,#FF2D68_100%)] text-white";

    case "INSTAGRAM":
      return "bg-[radial-gradient(circle_at_30%_107%,#FDF497_0%,#FDF497_5%,#FD5949_45%,#D6249F_60%,#285AEB_90%)] text-white";
    default: {
      const _exhaustive: never = platformType;
      return _exhaustive;
    }
  }
}
